import React, { useEffect } from 'react'
import { Form, Input } from 'antd'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import bxlutils from 'bxl-utils'
import utils from '@utils/utils'

export interface IFormProps {
  setParams: (params?: any, p?: string) => void
  paramValue?: string
  paramName?: string
  decode?: boolean
}
const FormItem = Form.Item
const CommonForm = (props: IFormProps) => {
  const { setParams, paramValue, paramName, decode } = props
  useEffect(() => {
    if (!paramValue) setParams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if (!paramValue) {
    return <></>
  }
  const changeText = e => {
    const value = e.target.value.trim()
    setParams({
      [paramValue]: decode ? utils.encode(value) : value,
    })
  }
  return (
    <FormItem label={paramName}>
      <Input onChange={changeText}></Input>
    </FormItem>
  )
}

export default CommonForm
